import { render, staticRenderFns } from "./OrderTrackerPage.vue?vue&type=template&id=c2893bac&"
import script from "./OrderTrackerPage.vue?vue&type=script&lang=js&"
export * from "./OrderTrackerPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports